import { render, staticRenderFns } from "./PopupConfirmList.vue?vue&type=template&id=2d148f72&scoped=true"
import script from "./PopupConfirmList.vue?vue&type=script&lang=js"
export * from "./PopupConfirmList.vue?vue&type=script&lang=js"
import style0 from "./PopupConfirmList.vue?vue&type=style&index=0&id=2d148f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d148f72",
  null
  
)

export default component.exports